export default __webpack_public_path__ + "static/media/policies_folder.933f0435.png";